// @owners { team: patient-health }
import { COLORS } from '@alto/design-library-tokens';
import { ListItem, ListPage, Row } from '@alto/design-system';
import { useNavigation } from '@alto/navigation';
import React from 'react';

const data = ['item_1', 'item_2', 'item_3'];

export const NotificationCenter = () => {
  const { goBack } = useNavigation();

  return (
    <ListPage.Root>
      <ListPage.Content.FlatList
        data={data}
        ListHeaderComponent={
          <ListPage.Header.Root
            backgroundColor={COLORS.BACKGROUND_COLORS.TERTIARY_LIGHTEST}
            onDismiss={goBack}
          >
            <ListPage.Header.Content.Root>
              <Row center>
                <ListPage.Header.Content.Title>Notifications</ListPage.Header.Content.Title>
              </Row>
            </ListPage.Header.Content.Root>
          </ListPage.Header.Root>
        }
        renderItem={({ item }) => <ListItem title={item} />}
      />
    </ListPage.Root>
  );
};
